import { render, staticRenderFns } from "./AppReadonlyField.vue?vue&type=template&id=ec31e044"
import script from "./AppReadonlyField.vue?vue&type=script&lang=js"
export * from "./AppReadonlyField.vue?vue&type=script&lang=js"
import style0 from "./AppReadonlyField.vue?vue&type=style&index=0&id=ec31e044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VTextField})
